import { ThemaFromThemaRouter } from '../../../dtos';
import { content } from './TerminAnsprechpartnerCard.content';

export const printPM = (thema: Pick<ThemaFromThemaRouter, 'produktManager'>): string =>
  thema.produktManager ?? content.noInfoAvailable;

export const printFachkraft = (thema: Pick<ThemaFromThemaRouter, 'produktManagerAssistenz'>): string =>
  thema.produktManagerAssistenz ?? content.noInfoAvailable;

export const printTeamPlanning = (thema: Pick<ThemaFromThemaRouter, 'planungsinformation'>): string =>
  thema.planungsinformation?.verantwortlicherTeamPlanning ?? content.noInfoAvailable;
